<div class="d-flex">
  <div [formGroup]="form" class="col-6" style="height: 100vh; overflow-x: hidden; overflow-y: scroll;">
    <div class="p-1 pe-4" formGroupName="renter">
      <h4 class="fw-bold my-3 text-dark m-0">
        {{ 'RESIDENTS.RENTER_INFORMATION' | translate }}
      </h4>

      <div class="row">
        <div class="col-lg-6">
          <ng-select formControlName="renterType" inputValidator label="CONTRACT.RENTER_TYPE_TITLE">
            @for (clientType of [ClientType.PRIVATE, ClientType.BUSINESS, ClientType.ORGANIZATION]; track clientType) {
              <ng-option [value]="clientType">
                {{ "APARTMENT.RENTER_TYPE." + clientType | translate }}
              </ng-option>
            }
          </ng-select>
        </div>

        <div class="col-lg-6">
          <autocomplete
            [url]="getSalutation.bind(this)"
            formControlName="salutationId"
            inputValidator
            label="APARTMENT.SALUTATION"
          />
        </div>

        <div class="col-lg-6">
          <input
            class="form-control"
            formControlName="firstName"
            inputValidator
            label="USERS.FIRSTNAME"
          >
        </div>

        <div class="col-lg-6">
          <input
            class="form-control"
            formControlName="lastName"
            inputValidator
            label="RESIDENTS.LAST_NAME"
          >
        </div>

        @if (this.form.get('renter').get('renterType').value !== ClientType.PRIVATE) {
          <div class="col-lg-12">
            <input
              class="form-control"
              formControlName="companyName"
              inputValidator
              label="RESIDENTS.COMPANY_NAME"
            >
          </div>
        }

        <div class="col-lg-6">
          <input-validator formControlName="code" label="RESIDENTS.CODE">
            <div class="input-group">
              <input class="form-control" formControlName="code" readonly>
              <button class="btn btn-light" type="button" (click)="generateCode()">
                <i class="la la-refresh"></i>
              </button>
            </div>
          </input-validator>
        </div>

        <div class="col-lg-6">
          <input
            class="form-control"
            formControlName="phoneNumber"
            inputValidator
            label="RESIDENTS.PHONE"
            mask="+9999999999999"
            placeholder="+49 9999 9999999"
          >
        </div>

        <div class="col-lg-6">
          <input
            class="form-control"
            formControlName="email"
            inputValidator
            label="RESIDENTS.EMAIL"
          >
        </div>

        <div class="col-lg-6">
          <input-validator formControlName="bankIban" label="APARTMENT.IBAN">
            <div class="input-group">
              <p-inputMask
                class="form-control p-0 border-none"
                formControlName="bankIban"
                inputId="bankIban"
                mask="aa99999999999999999999"
                placeholder="DE89 3704 0044 0532 0532 84"
                (onBlur)="searchBank()"
              >
              </p-inputMask>
            </div>
          </input-validator>
        </div>
        <div class="col-lg-6">
          <input
            class="form-control"
            formControlName="bankAccountHolder"
            inputValidator
            label="APARTMENT.ACCOUNT_HOLDER"
          >
        </div>

        <div class="col-lg-6">
          <input
            [readonly]="true"
            class="form-control"
            formControlName="bankBic"
            inputValidator
            label="RESIDENTS.BANK_BIC"
          >
        </div>
        <div class="col-lg-6">
          <input
            class="form-control"
            formControlName="bankName"
            inputValidator
            label="INVOICES.BANK_NAME"
          >
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8">
          <input
            class="form-control"
            formControlName="street"
            inputValidator
            label="ADDRESS.STREET"
          >
        </div>
        <div class="col-lg-4">
          <input
            class="form-control"
            formControlName="houseNumber"
            inputValidator
            label="RESIDENTS.NUMBER"
          >
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <input
            class="form-control"
            formControlName="postalCode"
            inputValidator
            inputmode="numeric"
            label="STREETS.POSTALCODE"
            mask="99999"
            placeholder="12345"
            style="width: 100%;"
            (blur)="searchCity()"
          />
        </div>
        <div class="col-lg-4">
          <input
            class="form-control"
            formControlName="city"
            inputValidator
            label="STREETS.CITY"
          >
        </div>

        <div class="col-lg-4">
          <input
            class="form-control"
            formControlName="country"
            inputValidator
            label="APARTMENT.COUNTRY"
          >
        </div>
      </div>

    </div>

    <div class="p-1 pe-4" formGroupName="rentalDetails">
      <h4 class="fw-bold my-3 text-dark m-0">
        {{ 'CONTRACT.RENTAL_DETAILS' | translate }}
      </h4>

      <div class="row mb-3">
        <div class="col-lg-12">
          <ng-select
            [clearable]="false"
            [items]="[ContractRentType.BUILDING, ContractRentType.APARTMENT]"
            formControlName="rentType"
            inputValidator
            label="CONTRACT.CONTRACT_TYPE"
          >
            <ng-template let-item="item" ng-label-tmp>
              <span>{{ "CONTRACT.TYPES." + item | translate }}</span>
            </ng-template>
            <ng-template let-item="item" ng-option-tmp>
              <span>{{ "CONTRACT.TYPES." + item | translate }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-lg-12">
          <autocomplete
            [url]="propertyService.getActiveAll.bind(propertyService)"
            formControlName="buildingId"
            inputValidator
            label="METER.PROPERTY"
          >
            <ng-template #label let-item="item" ng-label-tmp>
              {{ item?.name }}{{ item.addressBook ? ' - ' + item.addressBook.addressLine1 : '' }}
            </ng-template>
          </autocomplete>
        </div>
      </div>

      @if (this.form.get('rentalDetails').get('rentType').value == ContractRentType.APARTMENT) {
        <div class="row mb-3">
          <div class="col-lg-12">
            <autocomplete
              inputValidator
              label="METER.APARTMENT"
              formControlName="apartmentId"
              [parentControl]="this.form.get('buildingId')"
              [url]="apartmentsService.getAll.bind(apartmentsService)"
              parentFilterName="buildingId"
              bindLabel="apartmentName"
            />
          </div>
        </div>
      }

      <div class="row">
        <div class="col-lg-4">
          <datepicker formControlName="startDate" inputValidator label="CONTRACT.START_DATE" placement="bottom"/>
        </div>
        <div class="col-lg-4">
          <datepicker
            formControlName="endDate"
            inputValidator
            label="CONTRACT.END_DATE"
            placement="bottom"
          />
        </div>
        <div class="col-lg-4">
          <div class="unbefristet">
            <kep-input-label [label]="'CONTRACT.PERMANENT' | translate"></kep-input-label>
            <div class="m-2">
              <p-checkbox [binary]="true" formControlName="permanent" id="permanent" inputId="permanent"/>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-lg-12 fw-bold fs-5 mb-2">
          {{ 'CONTRACT.RESIDENTS_QUESTION' | translate }}
        </div>
        <div class="col-lg-4">
          <p-inputNumber
            [useGrouping]="false"
            class="w-100"
            formControlName="residentsQuantity"
            inputStyleClass="form-control"
            inputValidator
            label="CONTRACT.RESIDENTS_COUNT"
            styleClass="w-100"
          />
        </div>
      </div>
    </div>

    <div class="p-1 pe-4" formGroupName="payment">
      <h4 class="fw-bold my-3 text-dark m-0">
        {{ 'CONTRACT.OPERATING_COST_QUESTION' | translate }}
      </h4>

      <div class="flex flex-col gap-4">
        @for (type of rateTypeList; track type) {
          <div class="field-checkbox d-flex gap-3 my-3">
            <p-radioButton
              formControlName="unitType"
              [inputId]="'type_' + type.id"
              [value]="type.id"
              name="unitType"/>
            <label [for]="'type_' + type.id" class="ml-2 fs-5 mb-1">{{ type.label | translate }} </label>
          </div>
        }
      </div>
      <div class="d-flex flex-wrap gap-2">
        @for (field of fields; track field) {
          <div>
            <p-inputNumber
              [maxFractionDigits]="5"
              [minFractionDigits]="0"
              [useGrouping]="false"
              [formControlName]="field.id"
              inputValidator
              [label]="field.label"
              mode="decimal"
              styleClass="w-100"
              [mask]="99"
            />
          </div>
        }
        <div>
          <datepicker formControlName="validFrom" inputValidator label="CONTRACT.VALID_FROM"/>
          <input
            class="form-control"
            formControlName="totalPrepayment"
            inputValidator
            type="number"
            label="PAYMENT.AMOUNT"
          >
        </div>
        @if (this.form.get('payment').get('unitType').value !== ContractRateType.FlatRateRent) {
          <div>
            <kep-input-label [label]="'CONTRACT.TOTAL_RENT' | translate"></kep-input-label>
            <div class="form-control b-none">{{ total | customNumber }}</div>
          </div>
        }
      </div>
    </div>

    <div class="p-1 pe-4" formGroupName="deposit">
      <h4 class="fw-bold my-3 text-dark m-0">
        {{ 'CONTRACT.DEPOSIT' | translate }}
      </h4>

      <div class="row">
        <div class="col-lg-6">
          <ng-select
            [clearable]="false"
            [items]="depositTypeList"
            formControlName="depositType"
            inputValidator
            label="CONTRACT.DEPOSIT_TYPE"
          >
            <ng-template let-item="item" ng-label-tmp>
              <span>{{ "APARTMENT.DEPOSIT_TYPE." + item | translate }}</span>
            </ng-template>
            <ng-template let-index="index" let-item="item" let-search="searchTerm" ng-option-tmp>
              <span>{{ "APARTMENT.DEPOSIT_TYPE." + item | translate }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="d-flex flex-wrap gap-3 mt-3">
        <input-validator
          [label]="'CONTRACT.DEPOSIT_AMOUNT' | translate"
          class="fs-5 mb-1"
          formControlName="depositAmount">
          <div>
            <p-inputNumber
              [maxFractionDigits]="5"
              [minFractionDigits]="0"
              [useGrouping]="false"
              formControlName="depositAmount"
              mode="decimal"
              styleClass="w-100"
            />
          </div>
        </input-validator>
        <div>
          <input-validator
            [label]="'CONTRACT.DEPOSIT_DUE_DATE' | translate"
            class="fs-5 mb-1"
            formControlName="depositDueDate">
            <datepicker formControlName="depositDueDate"/>
          </input-validator>
        </div>
      </div>
      <div class="d-flex flex-wrap gap-3 mt-3">
        <div class="d-flex gap-3 align-items-end">
          @for (
            depositPayment of [DepositPayment.ONE_TIME_PAYMENT, DepositPayment.PAYMENT_IN_3_MONTHS]; track depositPayment) {
            <div class="d-flex align-items-center gap-1">
              <p-radioButton
                formControlName="depositPayment"
                [inputId]="'' + depositPayment"
                [value]="depositPayment"
                name="depositPayment"/>
              <kep-input-label
                class="fs-5 mb-1"
                [disabled]="this.form.get('deposit').get('depositPayment').disabled"
                [label]="'APARTMENT.DEPOSIT_PAYMENT.' + depositPayment"
                [for]="'depositPayment_' + depositPayment"
              />
            </div>
          }
        </div>
      </div>
    </div>
    <!--        <app-contact-exceptions-form [form]="form"-->
    <!--                                     [propertyId]="form.get('rentalDetails').value?.buildingId"></app-contact-exceptions-form>-->
    <h4 class="fw-bold my-3 text-dark m-0">
      {{ 'APARTMENT.NOTES' | translate }}
    </h4>

    <textarea
      class="form-control"
      formControlName="notes"
      inputValidator
      placeholder=""
      rows="10"
    ></textarea>

    <div class="d-flex mt-2 justify-content-end align-items-center gap-2">
      <p-button (click)="onSubmit()" [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'SAVE'|translate"></p-button>
      <button (click)="cancel()" class="btn btn-soft-primary" type="button">{{ 'CANCEL' | translate }}</button>
    </div>
  </div>
  <div class="col-6 pdf-preview">
    <iframe [src]="pdfUrl" style="height:100vh;border:0;" width="100%"></iframe>
  </div>
</div>
